export default __webpack_public_path__ + "static/media/right.13bb32d9.svg";